import { Link } from "react-router-dom";
import { ArrowLeftRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const IMG =
  "https://images.pexels.com/photos/8482859/pexels-photo-8482859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260";

export default function TradeInBanner() {
  return (
    <section data-testid="tradein-banner" className="py-24 md:py-32 relative overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden border border-[#F57C00]/30 bg-[#122659]">
          <Reveal className="p-10 md:p-14 flex flex-col justify-center">
            <span className="inline-flex items-center gap-2 text-[#F57C00] text-xs uppercase tracking-[0.25em] font-bold mb-5">
              <ArrowLeftRight size={16} /> Trade-in
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white mb-5">
              Already driving something? It counts.
            </h2>
            <p className="text-base text-slate-400 leading-relaxed mb-8 max-w-md">
              Your current car has value here. We'll assess it fairly and put it
              towards your CompCar deal — it can even cover your ownership
              deposit on a rent-to-own plan.
            </p>
            <div>
              <Link
                to="/trade-in"
                data-testid="tradein-banner-cta"
                className="inline-flex items-center gap-2 bg-[#F57C00] hover:bg-[#E67300] text-white font-bold px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-1"
              >
                Get my trade-in value <ArrowRight size={18} />
              </Link>
            </div>
          </Reveal>
          <div className="relative min-h-[280px] lg:min-h-0">
            <img src={IMG} alt="Keys changing hands at CompCar Motors" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#122659] via-[#122659]/40 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
